import {TariffsInfoContainer} from '../containers/Documents/TariffsInfoContainer'

export const TariffsInfo = () => (
    <>
        <TariffsInfoContainer />
    </>
)